import {RichText} from '@gongxigames/framework/core/fragments/display';

const YELLOW_COLOR = '#FFC000';

RichText.setStyle('PromotionCounterTitle', {
    fontFamily: 'Roboto',
    fontSize: 38,
    fontWeight: 'bold',
    fill: 'white',
    wordWrap: true,
    wordWrapWidth: 335,
    align: 'center'
});

RichText.setStyle('PromotionTitleAndTitle', {
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: 64,
    fill: YELLOW_COLOR,
    wordWrap: true,
    wordWrapWidth: 335,
    align: 'center'
});

RichText.setStyle('PromotionCounterAmount3Rows', {
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: 110,
    fill: YELLOW_COLOR,
    wordWrap: true,
    wordWrapWidth: 335,
    align: 'center'
});

RichText.setStyle('PromotionCounterAmount4Rows', {
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: 110,
    fill: YELLOW_COLOR,
    wordWrap: true,
    wordWrapWidth: 335,
    align: 'center'
});

RichText.setStyle('PromotionCounterBet3Rows', {
    fontFamily: 'Roboto',
    fontWeight: 'normal',
    fill: '#B2B2B2',
    fontSize: 38,
    wordWrap: true,
    wordWrapWidth: 335,
    align: 'center'
});

RichText.setStyle('PromotionCounterBet4Rows', {
    fontFamily: 'Roboto',
    fontWeight: 'normal',
    fill: 'white',
    fontSize: 38,
    wordWrap: true,
    wordWrapWidth: 335,
    align: 'center'
});

RichText.setStyle('PromotionCounterId', {
    fontFamily: 'Roboto',
    fontWeight: 'normal',
    fill: '#B2B2B2',
    fontSize: 38,
    wordWrap: true,
    wordWrapWidth: 335,
    align: 'center'
});
